import React from "react";

//interfaces
import { IAudioPlayer } from "../../../../interfaces/media/IAudio";

//components
import AudioBackground from "./AudioBackground";



const AudioPlayer = ({className, contentTitle, contentUrl, audioCaption, featuredImage}: IAudioPlayer) => {
    return (
        <div className={`audio-player-wrapper ${className}`} >
            <div className="audio-player-background">
                {featuredImage
                    ?   <img
                            className="audio-featured-image-background"
                            src={featuredImage}
                        />
                    :   <AudioBackground />
                }

                <div className="audio-player-details">
                    <h4 className="audio-content-title">{contentTitle}</h4>

                    <audio className="audio-player-component" controls preload="metadata">
                        <source src={contentUrl} type="audio/mpeg" />
                        Your browser does not support the audio element.
                    </audio>
                </div>
            </div>

            {audioCaption && <span className="audio-caption">{audioCaption}</span>}
        </div>
    );
};

export default AudioPlayer